import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const MyInterestsCode = () => {
  const code = `
    const FreeTime = () => {
      const MyInterests = [
        'I like to sketch/draw ✍️', 
        'take some pictures ̶o̶f̶ ̶m̶y̶s̶e̶l̶f̶  📸', 
        'read a book 📖',
        'play Warzone 🎮'
      ];
  `;

  return (
    <SyntaxHighlighter className='interests' language="javascript" style={dark}>
      {code}
    </SyntaxHighlighter>
  );
};

export default MyInterestsCode;
